import { z } from 'zod';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

export const zodTriggerSyncEndpointSchema = z.tuple([
  z.literal('sync'),
  z.literal('trigger'),
]);

export const zodTriggerSyncPayloadSchema = z
  .object({
    apiKey: z.string().nullish(),
    companyAccountId: z.uuid().nullish(),
    companyId: z.uuid().nullish(),
    env: z
      .preprocess(
        (value) => String(value).toLowerCase(),
        z.enum(['dev', 'prod']),
      )
      .optional()
      .prefault('prod'),
  })
  .transform((data) =>
    withoutObjectKeysWhereValueIs(data, [null, undefined, '']),
  );
